document.addEventListener('DOMContentLoaded', function () {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  document.querySelectorAll('.hero .rv').forEach(function (el) { el.classList.add('in'); });

  var toggle = document.querySelector('.menu-toggle');
  var menu = document.querySelector('.mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});

/* ---------------- collection: instant filter + sort ---------------- */
(function () {
  var form = document.getElementById('FacetForm');
  if (!form) return;
  form.addEventListener('change', function () {
    var params = new URLSearchParams(new FormData(form));
    window.location.href = window.location.pathname + '?' + params.toString();
  });
})();

/* ---------------- product: variants, size gate, modal, buy bar ---------------- */
(function () {
  var pdp = document.querySelector('.pdp');
  if (!pdp) return;

  var dataEl = document.getElementById('PdpVariants');
  if (!dataEl) return;
  var variants = JSON.parse(dataEl.textContent);
  var moneyFormat = JSON.parse(document.getElementById('PdpMoneyFormat').textContent || '"${{amount}}"');
  var labels = { gate: 'Choose your size', add: 'Add to bag', sold: 'Sold out' };
  var labelEl = document.getElementById('PdpLabels');
  if (labelEl) { try { labels = JSON.parse(labelEl.textContent); } catch (e) {} }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  var idInput = document.getElementById('PdpVariantId');
  var submit = document.getElementById('PdpSubmit');
  var submitText = document.getElementById('PdpSubmitText');
  var priceEl = document.getElementById('PdpPrice');
  var barBtn = document.getElementById('BuyBarBtn');
  var barPrice = document.getElementById('BuyBarPrice');
  var buyNow = document.querySelector('.pdp-buynow');
  var groups = document.querySelectorAll('.opt-group');

  function selectedOptions() {
    var opts = [];
    document.querySelectorAll('.opt-input:checked').forEach(function (input) {
      opts[parseInt(input.dataset.index, 10)] = input.value;
    });
    return opts;
  }

  function markUnavailable(opts) {
    document.querySelectorAll('.opt-input').forEach(function (input) {
      var idx = parseInt(input.dataset.index, 10);
      var trial = opts.slice();
      trial[idx] = input.value;
      var match = variants.find(function (v) {
        return trial.every(function (o, i) { return o === undefined || v.options[i] === o; });
      });
      var label = document.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.toggle('unavailable', !(match && match.available));
    });
  }

  function setButtons(text, enabled) {
    if (submit) submit.disabled = !enabled;
    if (submitText) submitText.textContent = text;
    if (barBtn) { barBtn.disabled = !enabled; barBtn.textContent = text; }
    if (buyNow) buyNow.style.display = enabled ? '' : 'none';
  }

  function update() {
    var opts = selectedOptions();
    markUnavailable(opts);

    /* every option group must have a choice before we can add to bag */
    var incomplete = false;
    for (var i = 0; i < groups.length; i++) {
      if (!groups[i].querySelector('.opt-input:checked')) { incomplete = true; break; }
    }
    if (incomplete) {
      setButtons(labels.gate, false);
      return;
    }

    var variant = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
    if (!variant) { setButtons(labels.sold, false); return; }

    if (idInput) idInput.value = variant.id;
    if (priceEl) {
      priceEl.innerHTML = '<span class="now">' + formatMoney(variant.price) + '</span>' +
        (variant.compare_at_price > variant.price ? '<s class="was">' + formatMoney(variant.compare_at_price) + '</s>' : '');
    }
    if (barPrice) barPrice.textContent = formatMoney(variant.price);
    setButtons(variant.available ? labels.add : labels.sold, variant.available);
    if (window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname + '?variant=' + variant.id);
    }
  }

  document.querySelectorAll('.opt-input').forEach(function (input) {
    input.addEventListener('change', update);
  });
  update();

  /* size guide modal */
  var overlay = document.getElementById('SizeGuide');
  var lastFocus = null;
  function openGuide() {
    if (!overlay) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    var closeBtn = overlay.querySelector('.sg-close');
    if (closeBtn) closeBtn.focus();
  }
  function closeGuide() {
    if (!overlay) return;
    overlay.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.querySelectorAll('[data-open-size-guide]').forEach(function (b) { b.addEventListener('click', openGuide); });
  document.querySelectorAll('[data-close-size-guide]').forEach(function (b) { b.addEventListener('click', closeGuide); });
  if (overlay) {
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeGuide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeGuide(); });
  }

  /* sticky buy bar */
  var bar = document.getElementById('BuyBar');
  if (bar && submit) {
    var barObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.hidden = e.isIntersecting; });
    }, { rootMargin: '-80px 0px 0px 0px' });
    barObserver.observe(submit);
  }
})();

/* ---------------- related products fallback fetch ---------------- */
(function () {
  var root = document.getElementById('RelatedRoot');
  if (!root || !root.dataset.url) return;
  fetch(root.dataset.url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var section = doc.querySelector('.related');
      if (section) root.replaceWith(section);
    })
    .catch(function () {});
})();
